/**
 * What a household must bring to an intake appointment (AB#598).
 *
 * INTERIM: the landing page's 7-item list, pending MSC's official list (decision ams-mh1).
 *
 * Not a copy. This imports the one checked-in source, `src/Cms.Services/Appointments/RequiredDocuments.json`,
 * which the API also embeds for the confirmation email, text and call and for the phone line's prompts, so
 * the website and every message name the same documents. Edit the JSON, never this file's output.
 * `RequiredDocumentsTests` (Cms.Services.Tests) fails if this stops importing it or a page hard-codes items.
 */
import source from "../../../Cms.Services/Appointments/RequiredDocuments.json";

export type RequiredDocumentsLanguage = "en" | "es";

export interface RequiredDocumentsText {
  /** The sentence that introduces the full list in a message. */
  intro: string;
  /** Every item, in full. */
  full: readonly string[];
  /** One sentence, short enough for a text message. */
  short: string;
  /** One sentence, written to be heard. */
  spoken: string;
}

interface RequiredDocumentsSource {
  status: string;
  en: RequiredDocumentsText;
  es?: Partial<RequiredDocumentsText>;
}

const documents = source as RequiredDocumentsSource;

/** True until the source is switched to MSC's official list. */
export const requiredDocumentsInterim = documents.status.toLowerCase() !== "official";

/**
 * The text in `language`. Spanish is machine-drafted (needs review), and any Spanish variant the source
 * leaves out falls back to English, the same rule the API and the phone line follow.
 */
export function requiredDocuments(language: RequiredDocumentsLanguage = "en"): RequiredDocumentsText {
  const english = documents.en;
  if (language === "en" || !documents.es) return english;

  const spanish = documents.es;
  return {
    intro: spanish.intro || english.intro,
    full: spanish.full && spanish.full.length > 0 ? spanish.full : english.full,
    short: spanish.short || english.short,
    spoken: spanish.spoken || english.spoken,
  };
}
